import styled from "styled-components";

export const EditorStyled = styled.div`
    min-height: 0px;
    height: 100%;
    flex-grow: 1;
    background-color: black;
`;
